import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ETAIEMENT_SCOPE_MATRIX } from '~/constant/etaiements/phases/scope-matrix';
import { Checkbox } from '~/lib/HooksFormFields';
import styles from './scope-matrix-form.module.scss';

const ScopeMatrixForm = ({ isPreview }: { isPreview: boolean }) => {
  const { control, watch } = useFormContext();
  const rows = watch('scopeMatrix.rows') || [];

  const getRowIndex = (rowId: string): number => (
    rows.findIndex((row: { id: string }) => row.id === rowId)
  );

  const renderCheckCell = (rowId: string, field: 'lvtec' | 'eiffage') => {
    const index = getRowIndex(rowId);
    if (index < 0) return <span className={styles.previewMark} />;
    const value = rows[index]?.[field];
    if (isPreview) {
      return <span className={styles.previewMark}>{value ? 'X' : ''}</span>;
    }
    return (
      <Checkbox
        name={`scopeMatrix.rows.${index}.${field}`}
        control={control}
        disabled={isPreview}
      />
    );
  };

  return (
    <div id="scope-matrix" className={styles.scopeMatrix}>
      <h4>{ETAIEMENT_SCOPE_MATRIX.title}</h4>
      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th className={styles.labelCell} />
              <th className={styles.checkCell}>{ETAIEMENT_SCOPE_MATRIX.columns.lvtec}</th>
              <th className={styles.checkCell}>{ETAIEMENT_SCOPE_MATRIX.columns.eiffage}</th>
            </tr>
          </thead>
          <tbody>
            {ETAIEMENT_SCOPE_MATRIX.sections.map((section) => (
              <React.Fragment key={section.id}>
                <tr className={styles.sectionRow}>
                  <td colSpan={3}>{section.label}</td>
                </tr>
                {section.rows.map((rowDef) => (
                  <tr key={rowDef.id}>
                    <td className={styles.labelCell}>{rowDef.label}</td>
                    <td className={styles.checkCell}>
                      {renderCheckCell(rowDef.id, 'lvtec')}
                    </td>
                    <td className={styles.checkCell}>
                      {renderCheckCell(rowDef.id, 'eiffage')}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ScopeMatrixForm;
